import { render, staticRenderFns } from "./UsersPrivilegeDiagnosisPlan.vue?vue&type=template&id=44f13a6c&scoped=true&"
import script from "./UsersPrivilegeDiagnosisPlan.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeDiagnosisPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f13a6c",
  null
  
)

export default component.exports